import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d7f7f19"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center",
  style: {"font-size":"40px"}
}
const _hoisted_2 = {
  key: 1,
  class: "center",
  style: {"font-size":"40px"}
}
const _hoisted_3 = {
  key: 2,
  class: "center p-px-6",
  style: {"text-align":"left","width":"100%"}
}
const _hoisted_4 = { style: {"max-width":"800px","margin-left":"auto","margin-right":"auto"} }
const _hoisted_5 = { style: {"font-size":"40px"} }
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = {
  class: "p-col",
  style: {"min-width":"350px"}
}
const _hoisted_8 = { style: {"margin-bottom":"8px"} }
const _hoisted_9 = {
  key: 0,
  style: {"margin-bottom":"8px"}
}
const _hoisted_10 = {
  class: "p-col",
  style: {"text-align":"center"}
}
const _hoisted_11 = { style: {"font-size":"20px"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("View on OpenSea")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("View online")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([{"width":"100%","height":"100%","position":"fixed"}, _ctx.dark_mode ? 'background-color: #000000; color: #FFFFFF' : null])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loading, {
          key: 0,
          active: ""
        }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: {"transition":"opacity ease-in 0.8s"},
          class: _normalizeClass(_ctx.show_text ? 'show-opacity' : 'hide-opacity')
        }, [
          (!_ctx.display)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "No display found"))
            : (_ctx.display && !_ctx.display.entity.token_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "No media loaded"))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.token?.name), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.token?.creator?.user?.username), 1),
                        (_ctx.top_bid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.top_bid), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, _toDisplayString(_ctx.token?.description), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_qrcode_vue, {
                          value: _ctx.token?.permalink,
                          size: 200,
                          level: 'M'
                        }, null, 8, ["value"]),
                        _createElementVNode("div", _hoisted_11, [
                          (!_ctx.token_meta || _ctx.token_meta.entity.platform == 'opensea')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_12
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_13
                              ], 64))
                        ])
                      ])
                    ])
                  ])
                ]))
        ], 2))
  ], 4))
}